import { AfterViewInit, Component, inject } from '@angular/core';
import { EnvironmentService, InternalAuthService } from '@eforall/common';
import embed from 'vega-embed';
import { AppDataService, FuncService } from '../../../../../services';
import { VegaService } from '../vega.service';


const OPTIONS = {
	actions: false,
};

@Component({
	selector: 'vega-part',
	standalone: true,
	imports: [],
	templateUrl: './vega.part.html',
	styleUrls: ['./vega.part.scss']
})
export class VegaPart implements AfterViewInit {

	public env = inject(EnvironmentService);
	public auth = inject(InternalAuthService);
	private func = inject(FuncService);
	public appData = inject(AppDataService);
	public vegaService = inject(VegaService);

	ngAfterViewInit() {
		setTimeout(() => {
			this.renderCharts();
		}, 2000);
	}

	async renderCharts() {
		const commonConfig: any = {
			width: 'container',
			height: 'container',
			autosize: { type: 'fit', contains: 'padding' }
		};

		// 1. Bar Chart
		const viz1 = await embed('#viz1', {
			...commonConfig,
			data: { values: [{ a: 'A', b: 28 }, { a: 'B', b: 55 }, { a: 'C', b: 43 }, { a: 'D', b: 91 }] },
			mark: 'bar',
			encoding: {
				x: { field: 'a', type: 'nominal' },
				y: { field: 'b', type: 'quantitative' }
			}
		}, OPTIONS);

		// 2. Scatter Plot
		embed('#viz2', {
			...commonConfig,
			data: { url: 'https://raw.githubusercontent.com/vega/vega/main/docs/data/cars.json' },
			mark: 'point',
			encoding: {
				x: { field: 'Horsepower', type: 'quantitative' },
				y: { field: 'Miles_per_Gallon', type: 'quantitative' },
				color: { field: 'Origin', type: 'nominal' }
			}
		}, OPTIONS);

		// 3. Line Chart
		embed('#viz3', {
			...commonConfig,
			data: { url: 'https://raw.githubusercontent.com/vega/vega/main/docs/data/stocks.csv' },
			transform: [{ filter: "datum.symbol==='GOOG'" }],
			mark: 'line',
			encoding: {
				x: { field: 'date', type: 'temporal' },
				y: { field: 'price', type: 'quantitative' }
			}
		}, OPTIONS);

		// 4. Area Chart
		embed('#viz4', {
			...commonConfig,
			data: { url: 'https://raw.githubusercontent.com/vega/vega/main/docs/data/unemployment-across-industries.json' },
			mark: 'area',
			encoding: {
				x: { field: 'date', type: 'temporal', timeUnit: 'yearmonth' },
				y: { aggregate: 'sum', field: 'count', type: 'quantitative' },
				color: { field: 'series', type: 'nominal' }
			}
		}, OPTIONS);

		viz1.view.resize().runAsync();
	}
}